import React from 'react';
import { InputSwitch } from 'primereact/inputswitch';

const Switch = ({ field, form, onChange, ...restProps }) => {
  const handleChange = (e) => {
    const { value } = e;

    form.setFieldValue(field.name, value);

    if (onChange) {
      onChange(value);
    }
  };

  const handleBlur = () => {
    form.setFieldTouched(field.name, true);
  };

  return (
    <InputSwitch
      checked={field.value}
      {...field}
      {...restProps}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default React.memo(Switch);
